import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { PasswordModalComponent } from "./password-modal/password-modal.component";
import { Router } from "@angular/router";
import * as _ from 'lodash';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { IUser } from "../../users-page/users/users.interface";
import { RoleLabels } from "../../users-page/users/users.constants";
import { ICounter, ICounterFilter } from "../../counters-page/counters/counters.interface";
import { ISetting, ISettingFilter } from "../../settings-page/settings/settings.interface";
import { ICompany } from "../../companies-page/companies/companies.interface";
import { MyErrorStateMatcher } from "../../../shared/util/error-state-matcher";
import { CountersService } from "../../counters-page/counters/counters.service";
import { CompaniesService } from "../../companies-page/companies/companies.service";
import { AuthService } from "../../../shared/services/auth.service";
import { SettingsService } from "../../settings-page/settings/settings.service";
import { DialogService } from "../../../shared/services/dialog/dialog.service";
import { SETTINGS } from "../../settings-page/settings/settings.constants";
import { CountersModalComponent } from "../../counters-page/counters/counter-modal/counters-modal.component";
import { CompaniesModalComponent } from "../../companies-page/companies/companies-modal/companies-modal.component";
import { IInformationDialogOptions } from "../../../shared/services/dialog/information-dialog/information-dialog-options.interface";

let self: any;


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {
  profile!: IUser;
  roleLabels: any = RoleLabels;
  filterCounter: ICounterFilter = {
    filters: {
      id: 'billing_counter',
    },
    sort: '',
    skip: 0,
    limit: 10000
  };
  filterSetting: ISettingFilter = {
    skip: 0,
    limit: 20
  };
  settings: ISetting[] = [];
  termAndCond: string = "";
  loading: boolean = false;
  counters: ICounter[] = [];
  companyId!: string;
  currentCompany!: ICompany;
  isManax: boolean = false;
  paymentMethodTypes: any = {}; //  = _.cloneDeep(PaymentMethodTypes);
  paymentMethodTypesKeys: any = []; // = Object.keys(this.paymentMethodTypes);
  paymentNumberTransfer!: string;
  form_tyc!: UntypedFormGroup;
  form_ntf!: UntypedFormGroup;
  newTyc: boolean = false;
  newNtf: boolean = false;
  submitted = false;
  saving: boolean = false;
  customErrorStateMatcher = new MyErrorStateMatcher();

  constructor(
    private fb: UntypedFormBuilder,
    public _CountersService: CountersService,
    private _CompaniesService: CompaniesService,
    private _AuthService: AuthService,
    private _SettingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    private _dialogService: DialogService,
    private router: Router,
    private _dialog: MatDialog,
  ) {
    self = this;
  }

  async ngOnInit() {
    this.filterCounter.company = this._AuthService.companyId(),
    this.isManax = this._AuthService.isRole('manax');
    this.profile = this._AuthService.profile();
    //console.log(this.profile);
    this.getCounters();
    this.companyId = this._AuthService.companyId();
    this.getCompany();
    this.getSetting();
    /* refactor */
    /* remove this test */
    /*
    const value = await this._SettingsService.getCompanySettingValue(SETTINGS.CUSTOMIZED);
    console.log(SETTINGS.CUSTOMIZED, value);
    */
  }

  getCompany(reset?: boolean) {
    this.loading = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterCounter.skip = 0;
      this.currentCompany = {};
    }
    this._CompaniesService.getCompany(this.companyId).subscribe((company) => {
      this.currentCompany = company;
      //console.log(this.currentCompany)
      this.loading = false;
    });
  }

  getCounters(reset?: boolean) {
    this.loading = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterCounter.skip = 0;
      this.counters = [];
    }
    this._CountersService.getCountersSeries(this.filterCounter).subscribe((counters) => {
      const filteredCounters = counters.filter((counter: any) => counter.reference_value.serie !== "DRAFT");
      //console.log(counters)
      this.counters = _.concat(this.counters, filteredCounters);
      this.loading = false;
    });
  }

  getSetting(reset?: boolean) {
    this.loading = true;
    if (reset) {
      window.scroll(0, 0);
      this.filterCounter.skip = 0;
      this.paymentMethodTypes = {};
      this.paymentMethodTypesKeys = [];
      this.paymentNumberTransfer = "";
    }

    // --------------- GET SETTING VALUE----------------

    this._SettingsService.getCompanySettingValue(SETTINGS.PAYMENT_OPTIONS)
      .then((el: string) => {
        this.paymentMethodTypes = JSON.parse(el);
        this.paymentMethodTypesKeys = Object.keys(this.paymentMethodTypes);
        //console.log(this.paymentMethodTypes);
        //console.log(this.paymentMethodTypesKeys);
      });

    this._SettingsService.getCompanySettingValue(SETTINGS.PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER)
      .then((el: string) => {
        this.paymentNumberTransfer = el;
        this.buildForm_ntf();
      });

    this._SettingsService.getCompanySettingValue(SETTINGS.INVOICE_TERMS_AND_CONDITIONS)
      .then((el: string) => {
        this.termAndCond = el;
        this.buildForm_tyc();
      });

    this.loading = false;
  }

  get f_tyc() { return this.form_tyc.controls; }
  buildForm_tyc() {
    this.form_tyc = this.fb.group({
      tyc: [this.termAndCond, [Validators.maxLength(200)]],
    });
  }

  get f_ntf() { return this.form_ntf.controls; }
  buildForm_ntf() {
    this.form_ntf = this.fb.group({
      ntf: [this.paymentNumberTransfer],
    });
  }

  changePassword() {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '500px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(PasswordModalComponent, config);

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  disableUser() {
    this.openUnderConstructionDialog();
  }

  openCompanySettings(company: ICompany) {
    const profileCompany: any = this.profile.company;
    const index = profileCompany.findIndex((cmp: any) => cmp._id == company._id);
    this.router.navigate(['/admin', index, 'settings-company']).then(() => {
      window.location.reload()
    });
  }

  openNewCountersModal() {
    this.openCountersModal({});
  }

  openCountersModal(counter: ICounter, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '600px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(CountersModalComponent, config);
    self.dialogRef.componentInstance.readOnly = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result)
      this.getCounters(true);
      self.dialogRef = null;
    });
  }

  // openSettingModal(code: string, readOnly: boolean = false) {

  //   let config = new MatDialogConfig();
  //   // config.disableClose = true;
  //   config.width = '400px';
  //   config.maxWidth = '90vw';
  //   config.viewContainerRef = this._viewContainerRef;
  //   self.dialogRef = this._dialog.open(SettingsModalValuesComponent, config);
  //   self.dialogRef.componentInstance.code = code;
  //   self.dialogRef.componentInstance.readOnly = readOnly;

  //   self.dialogRef.afterClosed().subscribe((result: any) => {
  //     self.dialogRef = null;
  //     this.getSetting(true);
  //   });
  // }

  openCompanyModal(company: ICompany) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '600px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(CompaniesModalComponent, config);
    self.dialogRef.componentInstance.company = company;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.editLogo = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      this.getCompany(true);
      self.dialogRef = null;
    });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  async onSubmit_tyc() {
    this.submitted = true;
    const data: any = _.cloneDeep(this.form_tyc.value);
    if (this.form_tyc.invalid) return;
    this.saving = true;

    try {
      await this._SettingsService.setCompanySettingValue("INVOICE_TERMS_AND_CONDITIONS", data.tyc);
    } catch (error) {
      console.error("Error al guardar la configuración:", error);
    } finally {
      this.getSetting(true);
      this.newTyc = false;
      this.saving = false;
    }
  }

  async onSubmit_ntf() {
    this.submitted = true;
    const data: any = _.cloneDeep(this.form_ntf.value);
    //console.log(data)
    if (this.form_ntf.invalid) return;
    this.saving = true;

    try {
      await this._SettingsService.setCompanySettingValue("PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER", data.ntf);
    } catch (error) {
      console.error("Error al guardar la configuración:", error);
    } finally {
      this.getSetting(true);
      this.newNtf = false;
      this.saving = false;
    }
  }
}